import request from '@/utils/request'
// 获取俱乐部基本信息
export function getClubBase (query) {
  return request({
    url: '/club/get',
    method: 'get',
    params: query
  })
}
// 获取图片列表
export function getClubImgs (query) {
  return request({
    url: '/club/img/desc/query',
    method: 'get',
    params: query
  })
}
// 获取列表
export function getClubList (query) {
  return request({
    url: '/club/desc/query',
    method: 'get',
    params: query
  })
}
// 列表详情
export function getClubListDetail (query) {
  return request({
    url: '/club/desc/get',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/club.js